/**
 * This is the twofaSceController.
 * @memberOf twofa Module
 * @namespace twofaSceController
 */

/**
 * @name twofaSceController
 * @desc Create the controller.
 * @param $scope
 * @param $translate
 * @param coreService
 * @param $log
 * @param $state
 * @param $window
 * @memberOf twofa Module.twofa Controller
 * @ngInject
 */
function twofaSceController($scope, $translate, coreService, $log, $state, $window) {
    // Assign this controller as the view-model.
    // It will be accessible as 'twofaSceController' within the HTML template.
    
    var vm = this;
  
    //properties
    vm.has_errors = false;
    vm.errorMessage= '';
    vm.productAppDisplayName = '';

    // Activate the controller.
    activate();
  
    // Activates the controller.
    function activate() {
  
        // Read Identity Server's data model
        var model = coreService.getIdentityModel();
        if(model == null || typeof(model.data) === 'undefined'){
            $state.go('error');
        }

        $scope.model = model;
        vm.has_errors = $scope.model.has_errors;
        vm.errorMessage = $scope.model.errorMessage;
        vm.twoFactorAuthenticationType = $scope.model.two_factor_auth_type;
        
        if($scope.model.data != null){
            if($scope.model.data.productAppDisplayName != null && typeof($scope.model.data.productAppDisplayName) !== 'undefined'){
                vm.productAppDisplayName = $scope.model.data.productAppDisplayName;
            }
        }
    }
  }
  
  export default twofaSceController;


// WEBPACK FOOTER //
// ./src/login/2fa/sce/2fa.sce.controller.js